export default __webpack_public_path__ + "static/char-s-06-kr-c248e5eb0b6165109a5f25c6a972c62e.webp";